var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"M22.9,0C10.2,0,0,10.3,0,22.9S22.9,60,22.9,60s22.9-24.4,22.9-37.1S35.6,0,22.9,0z M22.9,57 c-2.1-2.3-6-6.8-9.9-12.1C5.8,35.2,2,27.6,2,22.8C2,11.3,11.4,1.9,22.9,1.9s20.9,9.5,20.9,21c0,4.7-3.8,12.4-11,22.1 C28.9,50.2,25,54.7,22.9,57z","key":0}),React.createElement("path",{"d":"M22.9,11c-6,0-10.8,4.8-10.8,10.8s4.8,10.8,10.8,10.8s10.8-4.8,10.8-10.8C33.7,15.9,28.9,11,22.9,11z M29.1,28.1c-1.6,1.6-3.8,2.6-6.2,2.6s-4.6-1-6.2-2.6c-1.6-1.6-2.6-3.8-2.6-6.2s1-4.6,2.6-6.2c1.6-1.6,3.8-2.6,6.2-2.6 s4.6,1,6.2,2.6c1.6,1.6,2.6,3.8,2.6,6.2S30.7,26.5,29.1,28.1z","key":1})]));
}

Pin.defaultProps = {"version":"1.1","width":"45.8","height":"60","viewBox":"0 0 45.8 60"};

module.exports = Pin;

Pin.default = Pin;
